<template>
  <nav>
    <div class="nav_wrapper">
      <router-link to="/" class="logo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 212 264" fill="none">
          <path d="M106 16C63.2253 39.4777 24.1772 27.4128 10 18.4456V173.741C10 189.638 28.7848 221.925 57.3924 231.213C86 240.5 94.6582 246.702 106 252C117.341 246.702 126 240.501 154.607 231.213C183.215 221.925 202 189.638 202 173.741V18.4456C187.822 27.4128 148.774 39.4777 106 16Z" fill="#F8DE32" stroke="#F8DE32" stroke-width="20"/>
        </svg>
        <h1>
          Colegio Cayros
        </h1>
      </router-link>
      <ul>
        <li>
          <a class="Button email" href="https://outlook.com/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><rect fill="none" height="24" width="24" x="0"/><path d="M22,8.98V18c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2L2.01,6C2.01,4.9,2.9,4,4,4h10.1C14.04,4.32,14,4.66,14,5s0.04,0.68,0.1,1 H4l8,5l3.67-2.29c0.47,0.43,1.02,0.76,1.63,0.98L12,13L4,8v10h16V9.9C20.74,9.75,21.42,9.42,22,8.98z M16,5c0,1.66,1.34,3,3,3 s3-1.34,3-3s-1.34-3-3-3S16,3.34,16,5z"/></g></svg>
            Correo
          </a>
        </li>
        <li>
          <a class="Button" href="https://teams.microsoft.com/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/></svg>
            Aula Virtual
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {

}
</script>

<style lang="sass">
@import '../assets/css/app.sass'
nav
  width: 100%
  background-color: $primary_color
  z-index: 10
  height: 0
  overflow: hidden
  animation: grow ease-in-out .4s 3.2s forwards
  // box-shadow: 0 4px 20px 2px rgba(black, .07)
  position: sticky
  .nav_wrapper
    // width: 980px
    // margin: 0 auto
    padding: 0 40px
    padding-right: 0
    box-sizing: border-box
    display: flex
    align-items: center
    justify-content: space-between
    .logo
      display: flex
      align-items: center
      text-decoration: none
      &:active, &:focus
        outline: none
      svg
        width: 20px
        margin-right: 10px
      h1
        font-weight: 700
        color: white
        font-size: 15px
        font-family: $font
        letter-spacing: .05rem
        text-transform: uppercase
    ul
      height: 70px
      display: flex
      align-items: center
      justify-content: space-between
      font-family: $font
      li
        color: white
        text-transform: capitalize
        font-weight: 500
        a
          color: white
          text-decoration: none
      .Button
        display: flex
        align-items: center
        justify-content: center
        text-decoration: none
        width: 160px
        color: $primary_color
        background-color: $accent_color
        height: 70px
        font-size: 14px
        border-radius: 0
        svg
          width: 20px
          margin-right: 10px
          path
            fill: $primary_color
        &.email
          width: 110px
          margin-right: 10px
          background-color: transparent
          display: flex
          align-items: center
          color: white
          svg
            width: 20px
            margin-right: 10px
            path
              fill: white

@media screen and (max-width: 560px)
  nav
    // background-color: $primary_color
    animation: grow2 ease-in-out .4s 3.2s forwards
    .nav_wrapper
      justify-content: flex-end
      .logo
        display: none
      ul
        justify-content: flex-end
        width: 100%
        height: 55px
        li
          color: white
          .Button
            height: 55px

@media screen and (max-width: 400px)
  nav
    .nav_wrapper
      padding-left: 0
      ul
        width: 100%
        li
          flex: 1
          .Button
            width: 100%
            font-size: 13px
            &.email
              margin-right: 0
              width: 100%

</style>